import PropTypes from "prop-types"
import * as R from "ramda"

export const DATE_FORMAT = "YYYY-MM-DD"

export const MONTH_FORMAT = "YYYY-MM"

// date-fns doesn't support YYYY and DD (https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg/)
export const DATE_FNS_FORMAT = "yyyy-MM-dd"
export const MONTH_FNS_FORMAT = "yyyy-MM"

export const DATE_MODES = {
  SINGLE: "single",
  INTERVAL: "interval",
  MONTH: "month",
  ANYTIME: "anytime",
  TIME_TO_STAY: "timeToStay",
  NO_RETURN: "noReturn",
} as const

export const DATE_SHAPE = {
  mode: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  minStayDays: PropTypes.number.isRequired,
  maxStayDays: PropTypes.number.isRequired,
  final: PropTypes.bool.isRequired,
} as const

export const OUTBOUND_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  DATE_MODES.ANYTIME,
] as const

export const MULTICITY_OUTBOUND_DATE_MODES = [DATE_MODES.SINGLE, DATE_MODES.INTERVAL] as const

export const INBOUND_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  DATE_MODES.TIME_TO_STAY,
  DATE_MODES.ANYTIME,
  DATE_MODES.NO_RETURN,
] as const

export const DEPARTURE_DATE_MODES = [DATE_MODES.SINGLE, DATE_MODES.INTERVAL] as const
export const RETURN_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  DATE_MODES.TIME_TO_STAY,
  DATE_MODES.ANYTIME,
] as const

export const RANGE_DATE_MODES = [DATE_MODES.INTERVAL, DATE_MODES.ANYTIME] as const

export const TIME_TO_STAY_DATE_MODES = [DATE_MODES.TIME_TO_STAY] as const

export const DATE_LINK_SHAPE = {
  value: PropTypes.object.isRequired,
  opposite: PropTypes.object,
  field: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(R.values(DATE_MODES)),
  onHide: PropTypes.func.isRequired,
  onActive: PropTypes.func.isRequired,
  requestChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
} as const

export const DATE_CB_SHAPE = {
  [DATE_MODES.SINGLE]: PropTypes.func,
  [DATE_MODES.INTERVAL]: PropTypes.func,
  [DATE_MODES.MONTH]: PropTypes.func,
  [DATE_MODES.TIME_TO_STAY]: PropTypes.func,
  [DATE_MODES.ANYTIME]: PropTypes.func,
  [DATE_MODES.NO_RETURN]: PropTypes.func,
} as const

// types
// =====
export type DateMode = "single" | "interval" | "month" | "anytime" | "timeToStay" | "noReturn"

export type Date = {
  mode: string
  from: string
  to: string
  minStayDays: number
  maxStayDays: number
  final: boolean
}

export type DateLink = {
  value: Date
  opposite: Date | null | undefined
  field: string
  mode: DateMode
  onHide: (arg1: undefined) => void
  onActive: (arg1: undefined) => void
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestChange: (arg1?: any) => void
  isActive: boolean
}

export type SimpleDatePicker = {
  maxDate: string | null | undefined
  mindate: string | null | undefined
  modes: DateMode[]
}
